import { useFeatureFlagEnabled } from "posthog-js/react";

/**
 * Remote kill lever for the notifications surface. Inverted on purpose: the
 * inbox is ON unless the PostHog flag `disable-inbox` is explicitly true, so a
 * missing flag, flags still loading, an unreachable PostHog, or a build where
 * PostHog never mounts (anything but production) can never hide it by accident.
 *
 * Off means: no badge, no Notifications entry points, no polling. /inbox
 * itself still renders, so an emailed link never dead-ends.
 */
export const useInboxEnabled = (): boolean =>
  useFeatureFlagEnabled("disable-inbox") !== true;
